import CryptoJS from 'crypto-js';
import merchantTransaction from './merchantTransaction';
import aggregatorTransaction from './aggregatorTransaction';
import inputerMerchantTransaction from './inputerMerchantTransaction';
import inputerAggregatorTransaction from './inputerAggregatorTransaction';
import aggregatorSettlementTransaction from './aggregatorSettlementTransaction';
import merchantSettlementTransaction from './merchantSettlementTransaction';
import inputerAggregatorSettlementTransaction from './inputerAggregatorSettlementTransaction';
import inputerMerchantSettlementTransaction from './inputerMerchantSettlementTransaction';
import cptsTransaction from './cptsTransaction';
import inputerCptsTransaction from './inputerCptsTransaction';
import { postApi } from '../../lib/fetcher';
import nfcTransaction from './nfcTranscation';

const report = {
  namespaced: true,

  state() {
    return {
      loading: false,
      aggregatorList: [],
      merchantList: [],
      flashErrorMessage: '',
      flashError: false,
    };
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },
    setAggregator(state, { payload }) {
      state.aggregatorList = payload.data.list;
    },
    clearAggregator(state) {
      state.aggregatorList = [];
    },
    setMerchant(state, { payload }) {
      state.merchantList = payload.data.list;
    },
    clearMerchant(state) {
      state.merchantList = [];
    },
  },

  actions: {
    async getAggregator(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        sort_by: 'ID ASC',
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/client/aggregator/search-by-name`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setAggregator', {
          payload: responseData,
        });
      }
    },
    async getMerchant(ctx, { date, search, source }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        sort_by: 'ID ASC',
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/merchant/search-by-mid&source=${source}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setMerchant', {
          payload: responseData,
        });
      }
    },
  },

  modules: {
    merchantTransaction,
    aggregatorTransaction,
    inputerMerchantTransaction,
    inputerAggregatorTransaction,
    aggregatorSettlementTransaction,
    merchantSettlementTransaction,
    inputerAggregatorSettlementTransaction,
    inputerMerchantSettlementTransaction,
    cptsTransaction,
    inputerCptsTransaction,
    nfcTransaction
  },
};
export default report;
